import { AccessDenied } from '@/components/ui/access-denied';
import { useAccessControl } from '@/hooks/useAccessControl';
import { BannerDetailsModule } from '@/modules/banner-management/banner-details';
import { createFileRoute } from '@tanstack/react-router';
import z from 'zod';

const paramsSchema = z.object({
  bannerId: z.coerce.number().int().positive(),
});

export const Route = createFileRoute('/dashboard/banner-management/$bannerId')({
  parseParams: paramsSchema.parse,
  stringifyParams: params => ({
    bannerId: String(params.bannerId),
  }),
  component: BannerDetailsPage,
});

function BannerDetailsPage() {
  const { canAccessBannerManagement } = useAccessControl();
  if (!canAccessBannerManagement) return <AccessDenied />;

  return <BannerDetailsModule />;
}
